export default "__VITE_ASSET__DEG55TYm__"